import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const StatusBadge = () => {
  const [time, setTime] = useState(new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }));

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }));
    }, 60000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="flex items-center gap-2 px-3 py-1 bg-gray-100 dark:bg-gray-800/50 border border-gray-200 dark:border-gray-700 rounded-full">
      <motion.div
        animate={{ opacity: [1, 0.4, 1] }}
        transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
        className="w-2 h-2 bg-green-500 rounded-full shadow-[0_0_8px_#22c55e]"
      />
      <span className="text-[10px] md:text-xs font-mono text-gray-600 dark:text-gray-400 whitespace-nowrap">
        SYSTEM NOMINAL | {time}
      </span>
    </div>
  );
};

export default StatusBadge;
